import React from 'react';
import { OutageTypeExperience } from '../outage-type-experience/OutageTypeExperience';

export const ReportOutageMeterOn = () => {
  return (
    <>
      <OutageTypeExperience />
    </>
  );
};
